var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "channel-link",
      attrs: { href: _vm.twitterLink, target: "_blank" }
    },
    [
      _c(
        "span",
        {
          staticClass: "channel-icon twitter",
          style: _vm.style,
          attrs: { "aria-hidden": "true" }
        },
        [
          _c("icon", {
            attrs: { color: _vm.color, type: "twitter", filled: _vm.filled }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "visually-hidden" }, [_vm._v(_vm._s(_vm.a11y))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }